import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { SocialProofBar } from './components/SocialProofBar';
import { SystemOverview } from './components/SystemOverview';
import { ReadyToTeach } from './components/ReadyToTeach';
import { TheoryPractice } from './components/TheoryPractice';
import { Volumes } from './components/Volumes';
import { SemesterPreview } from './components/SemesterPreview';
import { FitCheck } from './components/FitCheck';
import { Bonuses } from './components/Bonuses';
import { StickyBuyBar } from './components/StickyBuyBar';
import { Offer } from './components/Offer';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { FormatNotice } from './components/FormatNotice';
import { Faqs } from './components/Faqs';
import { Contact } from './components/Contact';
import { Comparison } from './components/Comparison';
import { FinalCall } from './components/FinalCall';
import { ClosingWords } from './components/ClosingWords';
import { SiteFooter } from './components/SiteFooter';
import { InlineCta } from './components/InlineCta';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'Arsenał Nauczyciela Jazzu™ — Cały semestr gitary jazzowej gotowy do uczenia';
    initMetaPixel();
  }, []);
  return <div lang="pl" className="w-full overflow-x-hidden bg-night pb-[68px] font-sans text-cream sm:pb-0" data-id="element-0" data-mp="33lwzadal4ixo">
      <noscript data-id="element-1" data-mp="38kqd66tsabyd">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="38k6tolohjfi8" />
      </noscript>
      <PromoBar data-id="element-3" data-mp="nxn4pq48izmb" />
      <Hero data-id="element-4" data-mp="sunas11342df" />
      <Problems data-id="element-5" data-mp="sudoanf90dch" />
      <SocialProofBar data-id="element-6" data-mp="stub1k0jmd4s" />
      <ReadyToTeach data-id="element-7" data-mp="st2g8bersjfk" />
      <SemesterPreview data-id="element-8" data-mp="swqbpg3rzfwx" />
      <SystemOverview data-id="element-9" data-mp="3684hdq2uasw" />
      <TheoryPractice data-id="element-10" data-mp="35oy8u9shaup" />
      <Volumes data-id="element-11" data-mp="34x13f0jn52b" />
      <FitCheck data-id="element-12" data-mp="38kwyktgo3k7" />
      <Bonuses data-id="element-13" data-mp="38b2ol1dva8p" />
      <InlineCta tone="night-900" label="Chcę pakiet z 5 bonusami" data-id="element-14" data-mp="3ud1en72ulk9k" />
      <Offer data-id="element-15" data-mp="3uevqzx020421" />
      <HowItWorks data-id="element-16" data-mp="d4nwdiwxho3g" />
      <Guarantee data-id="element-17" data-mp="d57f31uekgij" />
      <FormatNotice data-id="element-18" data-mp="d3mn9jzh3bod" />
      <Faqs data-id="element-19" data-mp="d45ua5nl4fnm" />
      <InlineCta tone="night" label="Chcę gotowy semestr" data-id="element-20" data-mp="d2l936n5u92f" />
      <Comparison data-id="element-21" data-mp="86mev2f5hwu3" />
      <InlineCta tone="night-900" label="Zacznij uczyć z planem" data-id="element-22" data-mp="8648hcyry28g" />
      <FinalCall data-id="element-23" data-mp="3gklag2y7ng72" />
      <ClosingWords data-id="element-24" data-mp="3gm63tp8sgt3c" />
      <Contact data-id="element-25" data-mp="3glny8208l2ir" />
      <SiteFooter data-id="element-26" data-mp="3gj1s86szuv2n" />
      <StickyBuyBar data-id="element-27" data-mp="3bmjsxmgfnoxp" />
    </div>;
}